import { useEffect, useMemo } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import "./paymentpayhere.scss";

function PayhereError() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const reason = searchParams.get("reason");

  const message = useMemo(() => {
    if (reason === "token") {
      return "Subscription payment failed: PayHere recurring/tokenization is not enabled on this merchant account. Contact support.";
    }
    return "Payment failed. Please try again or contact support.";
  }, [reason]);

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/client/pay");
    }, 8000);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="pyment_error">
      <h1>Payment error</h1>
      <p className="pyment_error__message">{message}</p>
      <button type="button" onClick={() => navigate("/client/pay")}>
        Try again
      </button>
      <button
        type="button"
        className="pyment_error__secondary"
        onClick={() => navigate("/")}
      >
        Go to dashboard
      </button>
    </div>
  );
}

export default PayhereError;
